'use strict'
require("babel-polyfill");
// var colorify = require('colorify.js');
import 'objectFitPolyfill';
import 'url-polyfill'
import 'nodelist-foreach-polyfill'
import 'hammerjs'
// import 'custom-event-polyfill'

import Swiper from 'swiper/bundle'
// import Vm from './Vm.js'
 
import SmoothScroll from './_SmoothScroll.js'
import ScrollHelper from './_ScrollHelper.js'
import ResizeHelper from './_ResizeHelper.js'
import ScrollDirection from './_ScrollDirection.js'
import ResponsiveSwiper from './_ResponsiveSwiper.js'
// import Intersection from './_Intersection.js'
const TRANSITION_END = 'webkitTransitionEnd transitionend';



$(() => {
  const $window = $(window);
  const $body = $('body');
  const $header = $('.js_header')
  $body.addClass('loaded');

  // QA
  $('#qa').find('.qa').each(function(index, el){
    console.log(el)
    const $item = $(el);
    $item.find('.qa__q').on('click', () => {
      $item.toggleClass('active');
      $item.find('.qa__a').slideToggle(400);
      return false;
    })
  });

  // // ---------------------------------------------------------------
  // // scroll direction 
  // // ---------------------------------------------------------------
  // const scrollDirection = new ScrollDirection(function(e) {
  //   document.body.classList.toggle('scrolldown', e === 'down')
  //   $header.attr('data-active-item', null)
  // }, {
  //   startposition: 184,
  //   threshold: 80
  // })
  // $header.on('mouseover', e => {
  //   $body.addClass('menu-hover')
  // }).on('mouseleave', e => {
  //   $body.removeClass('menu-hover')
  // })
  // // ---------------------------------------------------------------
  // // scroll effect 
  // // ---------------------------------------------------------------
  // let windowHeight = window.innerHeight;
  // const target = $('body')
  // if ( target.length ) {
  //   let scrolltargetPos = target.length ? target.offset().top + target.outerHeight() : 0
  //   const resizeHelper = new ResizeHelper(() => {
  //     windowHeight = window.innerHeight;
  //     scrolltargetPos = target.offset().top + target.height()
  //   })
  //   const scrolled = new ScrollHelper(function(){
  //     const scrolltop = $(window).scrollTop()
  //     const _windowHeight = target.length ? scrolltargetPos : windowHeight
  //     $body.toggleClass('scrolled', scrolltop >= _windowHeight );
  //   });
  // }

  // // ---------------------------------------------------------------
  // // VM 
  // // ---------------------------------------------------------------

  // // const videoApp = createApp()
  // // videoApp.use(YouTube)
  // // videoApp.mount('#video')
  // // console.log(videoApp)

  // // const videoPlayers = new Vue({
  // //   el: '#video',
  // //   data() {
  // //     return {
  // //       selected: null,
  // //       playerVars: {
  // //         autoplay: 1,
  // //         playsinline: 1
  // //       }
  // //     }
  // //   },
  // //   methods: {
  // //     select: function(id) {
  // //       this.selected = parseInt(id)
  // //     },
  // //     close: function() {
  // //       this.selected = null
  // //     }
  // //   },
  // // })


  // // menu
  // $('.js-toggle-menu').on('click', e => {
  //   $body.toggleClass('menu-active')
  //   // $body.toggleClass('menubar-inactive')
  // })


  // // const $menu = $('.js_menu')
  // $('.js_menu-item').on('mouseover', e => {
  //   const hover = e.currentTarget.getAttribute('data-menu-item')
  //   $header.attr('data-active-item', hover)
  //   $
  // }).on('mouseleave', e => {
  //   $header.attr('data-active-item', null)
  // })
  // $('.js_submenu').on('click', e => {
  //   $header.attr('data-active-item', null)
  //   $body.removeClass('menu-active')
  // })

  // $('.js_toggle-submenu').on('click', e => {
  //   e.currentTarget.classList.toggle('active')
  //   const $submenu = $('#submenu-' + e.currentTarget.getAttribute('data-submenu-target'))
  //   $submenu.slideToggle()
  //   e.stopPropagation()
  //   e.preventDefault()
  //   return false
  //   // $header.attr('data-active-item', hover)
  // })


  // // expand profile
  // $('.js_truncated').on('click', e => {
  //   e.target.classList.add('expand')
  //   const target = e.target.getAttribute('data-target')
  //   const scrollBody = document.getElementById(target)
  //   scrollBody.addEventListener('transitionend', e => {
  //     scrollBody.style.height = `auto`
  //   })
  //   scrollBody.style.height = `${scrollBody.scrollHeight}px`
  // })

  // // case expand
  // $('.js_more').on('click', e => {
  //   e.currentTarget.style.display = 'none'
  //   const target = e.currentTarget.getAttribute('data-target')
  //   const scrollBody = document.getElementById(target)
  //   scrollBody.addEventListener('transitionend', e => {
  //     scrollBody.style.height = `auto`
  //   })
  //   scrollBody.style.height = `${scrollBody.scrollHeight}px`
  // })
  

  // $('.js-open-modal').on('click', e => {
  //   const id = e.currentTarget.getAttribute('data-modal-target')
  //   const modal = document.getElementById(id)
  //   const body = modal.querySelector('.modal__body')
  //   body.scrollTop = 0
  //   modal.classList.add('open')
  // })
  // $('.js-modal').each( ( index, el ) => {
  //   const modal = $(el)
  //   const ignore = $(el).find('.js-modal-ignore')
  //   const close = $(el).find('.js-modal-close')
  //   ignore.on('click', e => {
  //     e.stopPropagation()
  //     // console.log($(e.currentTarget).parent())
  //   })
  //   modal.on('click', e => {
  //     modal.removeClass('open')
  //   })
  //   close.on('click', e => {
  //     modal.removeClass('open')
  //   })
  // })

  // // responsive swiper
  // $('.js_slider').each((index, el) => {
  //   const next = el.querySelector('.js_slider__arrow--next')
  //   const prev = el.querySelector('.js_slider__arrow--prev')
  //   const offset = el.getAttribute('data-offset')
  //   const speed = el.getAttribute('data-speed') || 400
  //   new ResponsiveSwiper(el, {
  //     breakpoint: 750,
  //     slidesetting: {
  //       slidesPerView: 'auto',
  //       slidesPerGroup: 1,
  //       spaceBetween: 0,
  //       speed: speed,
  //       noSwiping: true,
  //       // allowTouchMove: false,
  //       // preventClicks: false,
  //       autoHeight: false,
  //       loop: true,
  //       centeredSlides: true,
  //       // pc 
  
  //       enabled: false,
  //       breakpoints: {
  //         751: {
  //           enabled: true,
  //           // speed: 12000,
  //           // noSwiping: true,
  //           // allowTouchMove: false
  //           slidesOffsetBefore: offset,
  //         },
  //       },
  //       navigation: {
  //         nextEl: next,
  //         prevEl: prev,
  //       },
  //     }
  //   })
  // })
  
  // // responsive swiper
  // $('.js_team-slider').each((index, el) => {
  //   const next = el.querySelector('.js_team-slider__arrow--next')
  //   const prev = el.querySelector('.js_team-slider__arrow--prev')
  //   const offset = el.getAttribute('data-offset')
  //   const speed = el.getAttribute('data-speed') || 400
  //   new ResponsiveSwiper(el, {
  //     breakpoint: 750,
  //     slidesetting: {
  //       slidesPerView: 'auto',
  //       slidesPerGroup: 1,
  //       spaceBetween: 0,
  //       speed: speed,
  //       noSwiping: false,
  //       allowTouchMove: true,
  //       autoHeight: false,
  //       loop: true,
  //       centeredSlides: true,
  //       // pc 
  
  //       enabled: false,
  //       breakpoints: {
  //         751: {
  //           enabled: true,
  //           slidesOffsetBefore: offset,
  //           initialSlide: 1,
  //         },
  //       },
  //       on: {
  //         click: function (e) {
  //           const clickedIndex = e.clickedSlide.getAttribute('data-slide-index')
  //           document.getElementById('team').setAttribute('data-active-item', clickedIndex)
  //         },
  //       },
  //       navigation: {
  //         nextEl: next,
  //         prevEl: prev,
  //       },
  //     }
  //   })
  // })

  // // swiper all device
  // $('.js_slider--all').each((index, e) => {
  //   const next = e.querySelector('.js_slider__arrow--next')
  //   const prev = e.querySelector('.js_slider__arrow--prev')
  //   // const offset = e.getAttribute('data-offset')
  //   const speed = e.getAttribute('data-speed') || 400
  //   const scrollbar = e.querySelector('.js_slider__scrollbar')
  //   new Swiper(e, {
  //     slidesPerView: 'auto',
  //     slidesPerGroup: 1,
  //     spaceBetween: 0,
  //     speed: speed,
  //     noSwiping: false,
  //     allowTouchMove: true,
  //     autoHeight: false,
  //     loop: true,
  //     centeredSlides: true,
  //     updateOnWindowResize: true,
  //     navigation: {
  //       nextEl: next,
  //       prevEl: prev,
  //     },
  //     scrollbar: {
  //       el: scrollbar,
  //       draggable: true,
  //       dragSize: 48
  //     },
  //     // pc 
  //     breakpoints: {
  //       751: {
  //         scrollbar: false,
  //         // noSwiping: true,
  //         // allowTouchMove: false,
  //         updateOnWindowResize: true,
  //         // speed: 12000,
  //       },
  //     },
  //   })
  // })
  // $('.js_slider--kv').each((index, e) => {
  //   const next = e.querySelector('.js_slider__arrow--next')
  //   const prev = e.querySelector('.js_slider__arrow--prev')
  //   // const scrollbar = e.querySelector('.js_slider__scrollbar')
  //   const speed = e.getAttribute('data-speed') || 400
  //   new Swiper(e, {
  //     slidesPerView: 'auto',
  //     slidesPerGroup: 1,
  //     spaceBetween: 0,
  //     speed: speed,
  //     autoHeight: false,
  //     loop: true,
  //     centeredSlides: true,
  //     navigation: {
  //       nextEl: next,
  //       prevEl: prev,
  //     },

  //     noSwiping: false,
  //     allowTouchMove: true,


  //     // scrollbar: {
  //     //   el: scrollbar,
  //     //   draggable: true,
  //     //   dragSize: 48
  //     // },

  //     // pc 
  //     breakpoints: {
  //       751: {
  //         loop: true,
  //         scrollbar: false,
  //         noSwiping: true,
  //         allowTouchMove: false,
  //         // speed: 12000,
  //       },
  //     },

  //   })
  // })


  // const modal_slider = $('.js_modal-advisor')

  // $('.js_open-modal-advisor').on('click', e => {

  //   const media = window.matchMedia('(max-width: 750px)')
  //   if(media.matches) {
  //     const index = $(e.currentTarget).attr('data-slide-index')
  //     document.querySelector('.advisor-modal').scrollTop = 0
  //     modal_slider.toggleClass('active')
  //     tvcm.slideTo(index, 0)
  //   }
  // })
  // $('.js_close-modal-advisor').on('click', e => {
  //   modal_slider.removeClass('active')
  // })






  // smooth scroll ------------------------------------------------------------
  function scrollTo(top){
    $('html,body').animate({ scrollTop: top }, {'easing': 'swing', 'duration': 500});
  }
  function calcScrollTo($el){
    // const offset = $('#nav').outerHeight() || 100;
    // const offset = $('.header').height();
    const offset = window.matchMedia('(min-width: 1200px)').matches ? 120 : $('.header').height()
    if($el.length){
      var to = $el.offset().top
    }else{
      var to = 0;
    }
    return to - offset;
  }
  $('a[href ^= "#"]').on('click', function(e){
    const $this = $(this);
    const id = $this.attr('href');
    if(id === '#') return false;
    const $el = $(id);
    scrollTo(calcScrollTo($el));

    if($this.hasClass('nohash')){
      e.preventDefault();
    }
    e.stopPropagation();
  });

  
});
